import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import budgetType from "@/views/module/budget/settings/budgetType.vue";
import budgetHead  from "@/views/module/budget/settings/budgetHead.vue";
import  budgetSubHead  from "@/views/module/budget/settings/budjetSubHead.vue";
import budget from "@/views/module/budget/budgets/budget.vue";
import budgetList from "@/views/module/budget/budgets/budgetList.vue";
import BudgetDetails from "@/views/module/budget/budgets/budgetDetails.vue";
import budgetReleaseCreate from "@/views/module/budget/budgetReleases/budgetRelease.vue";
import budgetReleaseList from "@/views/module/budget/budgetReleases/budgetReleaseList.vue";
import budgetReleaseDetails from "@/views/module/budget/budgetReleases/budgetReleaseDetails.vue";
import BudgetVariance from "@/views/module/budget/reports/budgetVariance.vue";
import BudgetConsumption from "@/views/module/budget/reports/budgetConsumption.vue";
import BudgetOverrun from "@/views/module/budget/reports/budgetOverrun.vue";
import BudgetSummary from "@/views/module/budget/reports/budgetSummary.vue";



export default [
{
    path: "/budget",
    name: "budget",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Budget",
    },
    children: [
        {
            path: "budget-types",
            name: "budget-types",
            meta: {
                breadcrumb: ["Budget", "Types"],
            },
            component: budgetType,
        },
        {
            path: "budget-heads",
            name: "budget-heads",
            meta: {
                breadcrumb: ["Budget", "Heads"],
            },
            component: budgetHead,
        },
        {
            path: "budget-sub-heads",
            name: "budget-sub-heads",
            meta: {
                breadcrumb: ["Budget", "Sub Heads"],
            },
            component: budgetSubHead,
        },
        {
            path: "budget-create/:id?",
            name: "budget-create",
            meta: {
                breadcrumb: ["Budget", "Create Budget"],
            },
            component: budget,
        },
        {
            path: "budget-records",
            name: "budget-records",
            meta: {
                breadcrumb: ["Budget", "Budget List"],
            },
            component: budgetList,
        },
        {
            path: "budget-details/:id",
            name: "budget-details",
            meta: {
                breadcrumb: ["Budget", "Budget Details"],
            },
            component: BudgetDetails,
        },
        {
            path: "budget-release-create/:id?",
            name: "budget-release-create",
            meta: {
                breadcrumb: ["Budget", "Create Budget Release"],
            },
            component: budgetReleaseCreate,
        },
        {
            path: "budget-release-records",
            name: "budget-release-records",
            meta: {
                breadcrumb: ["Budget", "Budget Release List"],
            },
            component: budgetReleaseList,
        },
        {
            path: "budget-release-details/:id",
            name: "budget-release-details",
            meta: {
                breadcrumb: ["Budget", "Budget Release Details"],
            },
            component: budgetReleaseDetails,
        },
        {
            path: "report/budget-variance",
            name: "budget-variance",
            meta: {
                breadcrumb: ["Budget", "Budget Variance"],
            },
            component: BudgetVariance,
        },
        {
            path: "report/budget-consumption",
            name: "budget-consumption",
            meta: {
                breadcrumb: ["Budget", "Budget Consumption"],
            },
            component: BudgetConsumption,
        },
        {
            path: "report/budget-overrun",
            name: "budget-overrun",
            meta: {
                breadcrumb: ["Budget", "Budget Overrun"],
            },
            component: BudgetOverrun,
        },
        {
            path: "report/budget-summary",
            name: "budget-summary",
            meta: {
                breadcrumb: ["Budget", "Budget Summary"],
            },
            component: BudgetSummary,
        },
    ],
  },
];
